import React from 'react';
import _ from 'lodash';
const languageList = require('language-list')();

const countries = require('country-data').countries;

const supportedLangCodes = [
  'en', 'ko', 'zh', 'ja', 'vi', 'es',
  'ar', 'de', 'fr', 'it', 'pt' ,'ru',
];

const otherLangs = languageList.getData().filter(({lang, code}) => !supportedLangCodes.includes(code));

const langOptions = [
  {
    code: 'en',
    language: (
      <span>
        <img src={require('../img/upload/language/English.png').default} alt='English' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> English</span>
      </span>
    ),
  },
  {
    code: 'ko',
    language: (
      <span>
        <img src={require('../img/upload/language/Korean.png').default} alt='Korean' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Korean</span>
      </span>
    ),
  },
  {
    code: 'zh',
    language: (
      <span>
        <img src={require('../img/upload/language/Chinese.png').default} alt='Chinese' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Chinese</span>
      </span>
    ),
  },
  {
    code: 'ja',
    language: (
      <span>
        <img src={require('../img/upload/language/Japanese.png').default} alt='Japanese' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Japanese</span>
      </span>
    ),
  },
  {
    code: 'vi',
    language: (
      <span>
        <img src={require('../img/upload/language/Vietnamese.png').default} alt='Vietnamese' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Vietnamese</span>
      </span>
    ),
  },
  {
    code: 'es',
    language: (
      <span>
        <img src={require('../img/upload/language/Spanish.png').default} alt='Spanish' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Spanish</span>
      </span>
    ),
  },
  {
    code: 'ar',
    language: (
      <span>
        <img src={require('../img/upload/language/Arabic.png').default} alt='Arabic' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Arabic</span>
      </span>
    ),
  },
  {
    code: 'de',
    language: (
      <span>
        <img src={require('../img/upload/language/German.png').default} alt='German' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> German</span>
      </span>
    ),
  },
  {
    code: 'fr',
    language: (
      <span>
        <img src={require('../img/upload/language/French.png').default} alt='French' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> French</span>
      </span>
    ),
  },
  {
    code: 'it',
    language: (
      <span>
        <img src={require('../img/upload/language/Italian.png').default} alt='Italian' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Italian</span>
      </span>
    ),
  },
  {
    code: 'pt',
    language: (
      <span>
        <img src={require('../img/upload/language/Portuguese.png').default} alt='Portuguese' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Portuguese</span>
      </span>
    ),
  },
  {
    code: 'ru',
    language: (
      <span>
        <img src={require('../img/upload/language/Russian.png').default} alt='Russian' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Russian</span>
      </span>
    ),
  },
  {
    code: 'others',
    language: (
      <span>
        <img src={require('../img/upload/language/others.png').default} alt='others' style={{marginRight:'6px'}} />
        <span style={{width:'96px'}}> Others</span>
      </span>
    ),
    others: otherLangs
  },
];

export const getCodeValue = (code) => {
  const foundLangOption = langOptions.find(lang => lang.code === code);
  if (foundLangOption && foundLangOption.code) {
    return [foundLangOption.code];
  }
  
  const foundOtherLangOption = otherLangs.find(lang => lang.code === code);
  if (!foundOtherLangOption) {
    console.log('Failed to find a language code,', code);
    return [];
  }
  
  return ['others', foundOtherLangOption.code];
}

export const getLanguage = (code) => {
  const foundLangOption = langOptions.find(lang => lang.code === code);
  if (foundLangOption && foundLangOption.code) {
    return foundLangOption.language
  }

  const foundOtherLangOption = otherLangs.find(lang => lang.code === code);
  if (!foundOtherLangOption) {
    console.log('Failed to find a language code,', code);
    return null;
  }

  return foundOtherLangOption.language;
}

export const getMatchedFlagEmoji = (code) => {
  let flag = code;
  switch (code) {
    case 'ko': flag = countries["KR"].emoji; break;
    case 'zh': flag = countries["CN"].emoji; break;
    case 'ja': flag = countries["JP"].emoji; break;
    case 'vi': flag = countries["VN"].emoji; break;
    case 'es': flag = countries["ES"].emoji; break;
    case 'ar': flag = countries["AE"].emoji; break;
    case 'de': flag = countries["DE"].emoji; break;
    case 'fr': flag = countries["FR"].emoji; break;
    case 'it': flag = countries["IT"].emoji; break;
    case 'pt': flag = countries["PT"].emoji; break;
    case 'ru': flag = countries["RU"].emoji; break;
    default: break;
  }

  return flag
}

export const getLanguageOption = (code) => {
  const optionIndex = langOptions.findIndex(lang => lang.code === code)
  if (code && optionIndex >= 0) {
    return {
      option: langOptions[optionIndex],
      index: optionIndex,
      isOther: false,
    };
  }

  const otherIndex = otherLangs.findIndex(lang => lang.code === code);
  if (otherIndex < 0) {
    console.log('Failed to find a language code,', code);
    return {};
  }

  return {
    option: otherLangs[otherIndex],
    index: otherIndex,
    isOther: true,
  }
}

export default langOptions;